export default __webpack_public_path__ + "static/media/hangInthere.b8008b5c.webp";